import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  statusChip: {
    fontSize: 11,
    fontWeight: 600,
    height: 22,
  },
  statusSuccess: {
    backgroundColor: theme.palette.statusLabel.success.secondary,
    color: theme.palette.statusLabel.success.primary,
  },
  statusError: {
    backgroundColor: theme.palette.statusLabel.error.secondary,
    color: theme.palette.statusLabel.error.primary,
  },
  statusPending: {
    backgroundColor: theme.palette.statusLabel.pending.secondary,
    color: theme.palette.statusLabel.pending.primary,
  },
  boolTrue: {
    color: theme.palette.statusLabel.error.primary,
    fontWeight: 700,
  },
  boolFalse: {
    color: theme.palette.text.disabled,
    fontWeight: 700,
  },
}))

export default useStyles
